<template>
  <AppLayout :title="`${movimentacao ? formaterService.operationType(movimentacao.type) : 'Movimentação'} #${id}`" back-to="movement">
    <div v-if="!movimentacao" class="text-muted">Carregando...</div>

    <div v-else>
      <div class="card mb-3">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3" v-if="movimentacao.customer">
              <strong>Cliente:</strong><br>
              {{ movimentacao.customer.name }}
            </div>
            <div class="col-md-3" v-if="movimentacao.supplier">
              <strong>Fornecedor:</strong><br>
              {{ movimentacao.supplier.name }}
            </div>
            <div class="col-md-3">
              <strong>Data:</strong><br>
              {{ formaterService.dateTime(movimentacao.date) }}
            </div>
            <div class="col-md-3" v-if="movimentacao.payment">
              <strong>Forma de pagamento:</strong><br>
              {{ movimentacao.payment_method?.name ?? formaterService.payment(movimentacao.payment) }}
            </div>
            <div class="col-md-3">
              <strong>Valor:</strong><br>
              {{ formaterService.currency(movimentacao.value) }}
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-md-3">
              <strong>Saldo:</strong><br>
              {{ formaterService.currency(movimentacao.balance) }}
            </div>
            <div class="col-md-3" v-if="movimentacao.cashier?.operator">
              <strong>Operador:</strong><br>
              {{ movimentacao.cashier.operator.name }}
            </div>
            <div class="col-md-3" v-if="movimentacao.description">
              <strong>Descrição:</strong><br>
              {{ movimentacao.description }}
            </div>
            <div class="col-md-3" v-if="movimentacao.operation_bill">
              <strong>Lançado na conta do cliente:</strong><br>
              {{ formaterService.currency(movimentacao.operation_bill.value) }}
            </div>
          </div>
        </div>
      </div>

      <h2 class="section-title">Produtos</h2>
      <div class="table-card">
        <table class="table">
          <thead>
            <tr>
              <th>Produto</th>
              <th>Quantidade</th>
              <th>Preço unitário</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in movimentacao.to_operation_products" :key="item.id">
              <td>{{ item.product?.name ?? ('Produto #' + item.product_id) }}</td>
              <td>{{ item.amount }} {{ item.product?.measure }}</td>
              <td>{{ formaterService.currency(item.price_uni ?? item.buy_uni) }}</td>
              <td>{{ formaterService.currency(item.price_total ?? item.buy_total) }}</td>
            </tr>
            <tr v-if="!movimentacao.to_operation_products?.length">
              <td colspan="4" class="text-center text-muted">Nenhum produto vinculado a esta movimentação.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </AppLayout>
</template>
<script>
import AppLayout from "@/components/AppLayout.vue";
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { movimentacoes } from "@/models/movimentacoes";
import formaterService from "@/services/formaterService";

export default {
  name: 'MovementDetailView',
  components: {
    AppLayout
  },
  setup() {
    const route = useRoute();
    const id = route.params.id;
    const movimentacao = ref(null);
    const Movimentacoes = movimentacoes();

    onMounted(async () => {
      movimentacao.value = await Movimentacoes.show(id);
    });

    return { id, movimentacao, formaterService }
  },
}
</script>
<style scoped>
.section-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-strong);
  margin-bottom: 0.75rem;
}
</style>
